import { BlogApiService } from '@/core';
import { BlogStatusValues, CommonStatusValues } from '@/shared';
import { Component, inject, signal } from '@angular/core';
import { CacTableComponent, table } from '@controladad/ng-base';
import { BlogEntity, BlogStatus } from '@repo/types';

@Component({
  selector: 'app-blogs',
  standalone: true,
  imports: [CacTableComponent],
  templateUrl: './blogs.component.html',
  styleUrl: './blogs.component.scss',
})
export class BlogsComponent {
  private readonly blogApi = inject(BlogApiService);

  totalBlogs = signal<number>(0);
  draftBlogs = signal<number>(0);
  disabledBlogs = signal<number>(0);

  table = table({
    itemsFn: this.blogApi.getAdapter(),
    view: {
      itemName: 'Blog',
    },
    columns: {
      id: { label: 'ID', sortable: true },
      title: { label: 'Title', sortable: true, filterable: true },
      image: { label: 'Cover image', type: 'image', transform: (v) => v?.url },
      createdAt: {
        label: 'Created At',
        sortable: true,
        type: 'datetime',
        filterable: [
          { type: 'greater', controlType: 'datetime', key: 'FromCreatedAt' },
          { type: 'lower', controlType: 'datetime', key: 'ToCreatedAt' },
        ],
      },
      status: {
        label: 'Status',
        items: BlogStatusValues,
        filterable: [
          {
            type: 'equal',
            multiple: true,
            key: 'statuses',
            controlType: 'select',
            items: BlogStatusValues,
          },
        ],
      },
      isDraft: {
        label: 'Is Draft',
        transform: (v) => (v ? 'Yes' : 'No'),
        sortable: true,
        filterable: [
          {
            type: 'equal',
            key: 'isDraft',
            controlType: 'select',
            items: [
              { value: true, label: 'Yes' },
              { value: false, label: 'No' },
            ],
          },
        ],
      },
    },
    actions: [
      {
        type: 'icon',
        content: 'edit',
        action: (item: BlogEntity) => dialog$.blog({ blog: item }).afterSubmit(),
      },
      {
        type: 'icon',
        content: 'trash',
        action: (item) => dialog$.deletePrompt(true).action(() => this.blogApi.deleteBlog(item.id)),
      },
    ],
    events: {
      add: () => dialog$.blog().afterSubmit(),
      response: (response) => {
        if (response && 'data' in response) {
          const blogs = response.data as BlogEntity[];

          if (response.extra) {
            if ('draftBlogsCount' in response.extra) {
              this.draftBlogs.set(response.extra.draftBlogsCount);
            }

            if ('disabledBlogsCount' in response.extra) {
              this.disabledBlogs.set(response.extra.disabledBlogsCount);
            }

            this.totalBlogs.set(response.pagination.total || blogs.length);
          } else {
            this.totalBlogs.set(blogs.length);
            this.draftBlogs.set(blogs.filter((blog) => blog.isDraft === true).length);
            this.disabledBlogs.set(blogs.filter((blog) => blog.status === 0).length);
          }
        }
      },
    },
  });
}
